<template><!-- svgo-optimised -->
<svg class="icon icon__check" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9.95153 16.8812L6 12.6714L6.98788 11.619L9.95153 14.7763L16.3121 8L17.3 9.05245L9.95153 16.8812Z" fill="white"/></svg>
</template>